import React from "react";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";

export const PublicRouter = ({
  component: Component,
  isAuthenticated,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      // Verifica si la ruta es para un producto específico
      if (!isAuthenticated && props.location.pathname.startsWith("/product")) {
        return <Component {...props} />;
      }

      if (!isAuthenticated) {
        return <Component {...props} />;
      }

      // Authenticated → redirect to lastPath if available, otherwise '/'
      const lastPath = localStorage.getItem("lastPath");
      if (lastPath && lastPath !== "/" && lastPath !== props.location.pathname) {
        localStorage.removeItem("lastPath");
        return <Redirect to={lastPath} />;
      }

      return <Redirect to='/' />;
    }}
  />
);
PublicRouter.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  component: PropTypes.func.isRequired,
};
